<template>
  <div class="event-settings" v-if="event">
    <h3 class="page-title">{{$t('inviteToEvent')}}</h3>
    <ui-hr>invite by event link</ui-hr>
    <ui-input v-clipboard:copy="link" readonly v-clipboard:success="onCopy" :title="$t('copyLink')" :value="link">
      <ui-icon slot="prefix" name="icon-file-copy">
      </ui-icon>
    </ui-input>
    <ui-hr>invite by unique link</ui-hr>
    <ui-input placeholder="input name" v-model="suffix">
      <span slot="prefix">{{host}}/s/</span>
    </ui-input>
    <ui-button @click="send">send</ui-button>

    <event-links :id="event.id"></event-links>
  </div>
</template>
<script>
import config from "../../config.js";
const siteConfig = config[process.env.NODE_ENV];
import api from '../../api/index.js'
import EventLinks from '../../components/event/event-link.vue'
export default {

  name: 'setting',

  data() {
    return {
      event: null,
      host: siteConfig.fullHost,
      suffix: ''
    }
  },
  components: {
    EventLinks
  },
  computed: {
    link() {
      return `${this.host}/e/${this.event.code}`
    }
  },
  methods: {
    onCopy() {
      this.$UiToast({
        message: this.$t("linkCopied")
      });
    },
    send() {
      if (!this.suffix) {
        return this.$UiToast.warning('please input a name')
      }
      api.createUniqueLink({
        aid: this.event.id,
        suffix: this.suffix
      }).then(res => {

      }).catch(err => {

      })
    }
  },
  mounted() {

    api
      .getContentById(this.$route.params.eventId)
      .then(res => {
        this.event = res.data.content
      })
      .catch(err => {
        console.log(err);
        //this.$router.push('/index')
      });

  }
}

</script>
<style lang="css" scoped>
</style>
